import { Dispatch, SetStateAction } from 'react';

import { ChangeStoreDesktop } from 'components/header/menu-system/change-store/ChangeStoreDesktop';
import { ChangeStoreMobile } from 'components/header/menu-system/change-store/ChangeStoreMobile';
import { useChangeStore } from 'components/header/menu-system/change-store/useChangeStore';
import { ConfirmModal } from 'components/modal';
import { ListagemProvider } from 'context/ListagemContext';
import { useBreakpoints } from 'hooks/useBreakpoints';

type ChangeStoreProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
};

export function ChangeStore({ open, setOpen }: ChangeStoreProps) {
    const { isUpMd } = useBreakpoints();
    const { openConfirm, setOpenConfirm, onConfirmChange, ...shellProps } = useChangeStore({ setOpen });

    return (
        <ListagemProvider>
            <ConfirmModal
                open={openConfirm}
                setOpen={setOpenConfirm}
                text="Ao confirmar a troca de empresa, você será redirecionado à tela inicial e todas alterações não salvas serão perdidas, gostaria de continuar?"
                confirm={onConfirmChange}
            />

            {isUpMd && <ChangeStoreDesktop open={open} setOpen={setOpen} {...shellProps} />}

            {!isUpMd && <ChangeStoreMobile open={open} setOpen={setOpen} {...shellProps} />}
        </ListagemProvider>
    );
}
